@if (isTeamMember()) {
  <app-context-menu [options]="{ noSpacing: true }" #menu>
    <button
      appButton
      name="preset-menu"
      location="gallery-settings-presets-dropdown"
      [hasIcon]="true"
      color="simple-primary"
      height="1"
      shape="round"
      data-test-id="preset-menu"
      contextButton
    >
      <span>Presets</span>
      <app-svg src="/assets/icons/16/chevron-down.svg" size="-1"></app-svg>
    </button>

    <div class="button-menu" contextContent>
      <h3 class="menu-list-title standard">STANDARD</h3>
      @for (preset of standardPresets(); track preset.id) {
        <app-button-menu-item
          icon="toggle"
          name="select-preset"
          [analyticsExtra]="{ preset: preset.id, type: 'standard' }"
          location="gallery-settings-presets-dropdown"
          [attr.data-test-id]="'standard_preset_' + preset.id"
          [fullWidth]="true"
          shape="round"
          [color]="currentPreset()?.id === preset.id ? 'simple-primary' : 'simple'"
          (onClick)="applyPreset(preset); menu.close()"
        >
          {{ preset.name }}
        </app-button-menu-item>
      }
      @if (customPresets()?.length || !currentPreset()) {
        <div class="divider"></div>
        <h3 class="menu-list-title standard">
          <span>CUSTOM</span>
          <app-upgrade-badge
            scope="gallery:custom-presets"
            location="gallery-settings-presets-dropdown"
          ></app-upgrade-badge>
        </h3>
        @for (preset of customPresets(); track preset.id) {
          <app-button-menu-item
            icon="gear-bg"
            name="select-preset"
            [analyticsExtra]="{ preset: preset.id, type: 'custom' }"
            location="gallery-settings-presets-dropdown"
            [attr.data-test-id]="'custom_preset_' + preset.name"
            [fullWidth]="true"
            shape="round"
            [color]="currentPreset()?.id === preset.id ? 'simple-primary' : 'simple'"
            (onClick)="applyPreset(preset); menu.close()"
          >
            {{ preset.name }}
          </app-button-menu-item>
        }

        @if (!currentPreset()) {
          <app-button-menu-item
            icon="plus-circle"
            name="save-preset"
            location="gallery-settings-presets-dropdown"
            [fullWidth]="true"
            shape="round"
            color="simple-primary"
            data-test-id="save-preset"
            (onClick)="saveCustomPreset(); menu.close()"
          >
            Save Preset
          </app-button-menu-item>
        }
      }
    </div>
  </app-context-menu>
}
